<!-- new-password-input-field.vue -->
<template>
  <div class="password-form-control">
    <input
      :type="schema.inputType"
      v-model="value"
      :disabled="disabled"
      :maxlength="schema.max"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly">
    <span>
      <button
        class="password-form-control-btn"
        type="button"
        @click="showPassword(schema.inputType === 'text')">
        <b-icon :icon="iconType"></b-icon>
      </button>
    </span>
  </div>
</template>

<script>
  import { abstractField } from "vue-form-generator";

  export default {
    mixins: [ abstractField ],
    data() {
      return {
        iconType: 'eye-slash-fill'
      }
    },
    methods: {
      showPassword(show) {
        this.schema.inputType = show ? 'password' : 'text'
        this.iconType = show ? 'eye-slash-fill' : 'eye-fill'
      }
    }
  };
</script>
